<template>
    <el-dialog class="haveTable" title="元数据模板位置详情" width="65%" append-to-body :close-on-click-modal="false" :visible.sync="visible">
        <div class="el-table-container">
            <el-table
                    :data="dataList"
                    v-loading="loading"
                    size="small" height="100%"
                    class="table" ref="multipleTable" border>
                <el-table-column prop="basicName" label="元数据模板名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="position" label="元数据位置" show-overflow-tooltip></el-table-column>
            </el-table>
            <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size" @pagination="refreshList"/>
        </div>
        <div slot="footer">
            <el-button size="small" @click="visible = false">关闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        data() {
            return {
                visible: false,
                loading: false,
                searchForm: {
                    current: 1,
                    size: 20,
                    basicId: '',
                    comparisonBasicDataId: '',
                    basicDataId: '',
                },
                dataList: [],
                total: 0,
            }
        },
        methods: {
            init(row, comparisonBasicDataId, basicDataId) {
                this.visible = true
                this.searchForm.basicId = row.basicId
                this.searchForm.comparisonBasicDataId = comparisonBasicDataId
                this.searchForm.basicDataId = basicDataId
                this.$nextTick(() => {
                    this.refreshList(1)
                })
            },
            refreshList(type) {
                if (type == 1) {
                    this.searchForm.current = 1
                }
                this.loading = true
                this.$axios(this.api.metadata.alikeDataDetail, this.searchForm, 'post').then(data => {
                    if (data.status) {
                        this.dataList = data.data.records
                        if (this.dataList.length == 0 && this.searchForm.current > 1) {
                            this.searchForm.current--
                            this.refreshList()
                        }
                        this.total = parseInt(data.data.total)
                        this.loading = false
                    }
                })
            },
        }
    }
</script>

<style scoped>

</style>
